import adminService from '../services/admin';

function initialState() {
  return {
    activeComponent: null,
    componentConfig: [],
    plants: [],
    users: []
  }
}

const state = initialState()

const mutations = {
  SET_PLANTS(state, payload) {
    state.plants = payload
  },
  SET_USERS(state, payload) {
    state.users = payload
  },
  SET_ACTIVE_COMPONENT(state, payload) {
    console.log('SETTING', payload);
    state.activeComponent = payload
  },
  SET_COMPONENT_CONFIG(state, payload) {
    state.componentConfig =  payload
  },
  CLEAR_STATE(state, stateKey) {
    const s = initialState()
    if (stateKey) {
      state[stateKey] = s[stateKey]
    } else
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
  },
  RESET_STATE(state) {
    let initial = initialState()
    Object.assign(state, initial)
  }
}

const actions = {
  setActiveComponent({commit}, payload) {
    commit('SET_ACTIVE_COMPONENT', payload)
  },
  fetchPlants({commit}) {
    console.log('FETCH plant');
    adminService.getAllPlant().then(result => {
      commit('SET_PLANTS', result.data.message)
    })
  },
  fetchUsers({commit}) {
    adminService.getAllUser().then(result => {
      commit('SET_USERS', result.data.message)
    })
  },
  fetchConfig({commit}, param) {
    const {component, identifier} = param
    const query = Object.entries(identifier).map(([key, value]) => `${key}=${value}`).join('&')
    console.log('param', param);
    adminService.fetchConfig(component, query).then(result => {
      commit('SET_COMPONENT_CONFIG', result.data.message)
    })
  },
  saveConfig({}, payload) {
    return adminService.saveConfig(payload)
  },
  updateConfig({}, payload) {
    return adminService.updateConfig(payload)
  },
  deleteConfig({}, payload) {
    const {component, identifier} = payload
    const query = Object.entries(identifier).map(([key, value]) => `${key}=${value}`).join('&')
    return adminService.deleteConfig(component, query)
  },
  clearState({commit}, stateKey) {
    console.log('ADMIN STATE');
    commit('CLEAR_STATE', stateKey)
  },
  resetState({commit}) {
    commit('RESET_STATE')
  }
}

const getters = {
  isPlantListEmpty: (state) => {
    return state.plants.length === 0
  },
  isUserListEmpty: (state) => {
    return state.users.length === 0
  },
  plantList: (state) => options => {
    let pl = state.plants
    if(options && options.length > 0) {
      pl = state.plants.map(element=> {
        return options.reduce((obj, key) => {
          obj[key] = element[key]
          return obj
        }, {})
      })
    }
  
    return pl
  },
  userList: (state) => options => {
    const ul = state.users.map(element=> {
      return options.reduce((obj, key) => {
        obj[key] = element[key]
        return obj
      }, {})
    })
  
    return ul
  },
  activeComponent: (state) => {
    return {
      name: state.activeComponent.name,
      component: state.activeComponent.component
    }
  },
  componentField: (state) => {
    return state.activeComponent.fields
  },
  componentData: (state) => {
    return state.componentConfig
  }
}

export default {
namespaced: true,
state,
mutations,
actions,
getters,
}